import React, { Component, Fragment } from 'react'
import { Container } from 'react-bootstrap'
import { Row,Col, Modal,Button } from 'react-bootstrap'

export class Culture extends Component {
  render() {
    return (
      <Fragment>
        <Container fluid={true} className='text-center CultureBackPic'>
              <hr />
            <h1 className='h1Tag'>Know About The Culture</h1>
            <div className='bottom'></div>
            <Row>
                <Col lg={6} md={6} sm={12} className='videoText'>
               
                </Col>


                <Col lg={6} md={6} sm={12} className='PhotoCard'>
                 <p className='pTag text-justify'>
               <h1>Know more about the Culture of Events</h1>  
                 <h6> “When Cultures Collide, Magic Happens”</h6>

             <h2>Free Events Host </h2>
<h6>Canada embraces its diverse cultural heritage through various festivals, celebrations, and events that showcase the traditions of different ethnic groups. </h6>

        <h2>Built-in Video conference Platform</h2>
   <h6>For every festival whether it's traditional or not we will provide the link to join with us before the festive begain.  </h6>

    <h2>Connect your attendees with events</h2>
  <h6>Festivals celebrating specific cultural groups, such as Lunar New Year, Diwali, and Eid-al-Fitr, are common in Canada. 
                 </h6> </p>
            
                </Col>
            </Row>

        </Container>


        
      </Fragment>
    )
  }
}

export default Culture
